import { Buttons, CoinBox, CoinText, Container, IconBox, ImageContainer, LogSubTitle, LogTitle, ManageCoins, ManageTitle, PersonInfo, PersonText, TransactionLog } from "./ManagementSide.styled";
import Coin_Icon from '@assets/svg/n_coin.svg';
import { useI18n } from '@i18n/useI18n';
import StudentThumbnail from "@components/StudentThumbnail";
import moment from "moment";
import { useRef, useState } from "react";
import db from "@utils/db";
import { useStore } from "@store/appStore";
import Cross_Icon from '@assets/svg/match/missing.svg'
import { BoxTop, Popup, PopupBox, RedeemGrid } from "../Redeembackup.styled";
import RainbowLoader from "@components/Loaders/RainbowLoader";
import Modal from "@components/Buttons/Modal";
import { CloseButton, ModalAccept, ModalButtons, ModalCancel, ModalContainer, ModalSubTitle, ModalText, ModalTitle } from "../RewardSide/RewardSide.styled";

interface IProps {
    student: any;
    updatestudent: any;
}

const ManagementSide = (props: IProps) => {
    const { client, callNameSetting } = useStore()
    const i18n = useI18n();
    const [amount, setAmount] = useState<any>("");
    const [logText, setlogText] = useState<string>("");
    const [positive, setPositive] = useState(null)
    const [showPopup, setShowPopup] = useState(false)
    const [transActionInProgress, setTransActionInProgress] = useState(false)
    // const [showNotEnoughPopup, setShowNotEnoughPopup] = useState(false)
    const ref1 = useRef(null);
    const ref2 = useRef(null);

    let name = props.student.name.trim().split(' ');

    const HandleInput = (e, field) => {
        if (field === "amount") {
            if (/^[()\d]+$/.test(e.target.value) || e.target.value === "") {
                if (!e.target.value.substring(1, e.target.value.length).includes('+') && !e.target.value.substring(1, e.target.value.length).includes('-'))
                    if(Number(e.target.value) > 10000)setAmount(10000)
                    else setAmount(e.target.value)
            }
        } else {
            setlogText(e.target.value)
        }
    }

    const show = (amount, positive) => {
        if (amount > 0) {
            setPositive(positive)
            setAmount(Math.abs(amount))
            setShowPopup(true)
        }
    }

    async function CreateTransaction() {
        let a = Math.abs(Number(amount))
        if ((!positive && a <= props.student.coins) || positive) {
            if (!positive) a = a * -1
            await db.MakeTransaction_Coins(props.student.id, 1, a, client.UserName, logText)
            setAmount("")
            setlogText("")
            await props.updatestudent()
        }
    }

    const completeTransaction = async () => {
        setTransActionInProgress(true)
        await CreateTransaction()
        close(null, true)
    }

    const close = (e, complete?) => {
        if (complete) {
            setPositive(null)
            setAmount(null)
        }
        setTransActionInProgress(false)
        setShowPopup(false)
    }


    return (<>
        {showPopup?<Modal ref={ref1} onClose={setShowPopup} backColor={"rgba(0,0,0,0.20)"}>
            <ModalContainer>
                {transActionInProgress ? <RainbowLoader /> : <>
                <CloseButton onClick={close}><Cross_Icon /></CloseButton>
                <ModalTitle>{i18n.t("confirm")}</ModalTitle>
                <ModalText>{i18n.t("transaction-popup-transaction-text", { coinState: positive ? i18n.t("give") : i18n.t("spend"), amount: amount, takeOrGive: positive ? i18n.t("to") : i18n.t("from"), adminSelectedStudent: props.student.name, adminSelection: props.student.username })}</ModalText>
                
                <ModalButtons>
                    <ModalCancel onClick={close}>{i18n.t("note-cancel")}</ModalCancel>
                    <ModalAccept onClick={completeTransaction}>{i18n.t("ok")}</ModalAccept>
                </ModalButtons>
                </>}
            </ModalContainer>
        </Modal>:null}
{/* 
        {showNotEnoughPopup?<Modal ref={ref2} onClose={setShowNotEnoughPopup} backColor={"rgba(0,0,0,0.20)"}>
            <PopupBox>
                <BoxTop>
                    <span>{i18n.t('oops')}</span>
                    <button onClick={() => ref2.current.handleClose()}>
                        <Cross_Icon />
                    </button>
                </BoxTop>
                <span></span>
                <p>{i18n.t(callNameSetting + "-transaction-popup-missing-coins")}</p>
                <div>
                    <button onClick={() => ref2.current.handleClose()}>{i18n.t("ok")}</button>
                </div>
            </PopupBox>
        </Modal>:null} */}

        <Container>            
            <PersonInfo>
                <ImageContainer>
                    <StudentThumbnail src={props.student.username} name={props.student.name} />
                </ImageContainer>
                <PersonText>
                    <span>{name[0]}</span>
                    <span>{name[1]}</span>
                </PersonText>
                <CoinBox>
                    <IconBox>
                        <Coin_Icon />
                    </IconBox>
                    <CoinText>
                        <span>{i18n.t("attender-coins")}</span>
                        <span>{props.student.coins}</span>
                    </CoinText>
                </CoinBox>
            </PersonInfo>
            <ManageCoins>
                <ManageTitle>{i18n.t("handle-coins")}</ManageTitle>

                <span>{i18n.t("transaction-amount1")} ({i18n.t("Max") + " 10000 Attender coins"})</span>
                <input onChange={(e) => HandleInput(e, "amount")} value={amount || ""} placeholder={i18n.t("write-amount")} />

                <span>{i18n.t("note-optional")}</span>
                <input maxLength={80} onChange={(e) => HandleInput(e, "log")} value={logText} placeholder={i18n.t("write-note")} />

                <Buttons>
                    <button disabled={Math.abs(Number(amount)) === 0 || Math.abs(Number(amount)) > props.student.coins || Math.abs(Number(amount)) > 10000} onClick={() => show(amount, false)}>-  {i18n.t("remove-coins")}</button>
                    <button disabled={Math.abs(Number(amount)) === 0 || Math.abs(Number(amount)) > 10000} onClick={() => show(amount, true)}>+  {i18n.t("add-coins")}</button>
                </Buttons>
            </ManageCoins>
            <TransactionLog>
                <LogTitle>{i18n.t("transaction-log")}</LogTitle>
                <LogSubTitle>{props.student?.logs.length} {i18n.t("redeem-transaction")}</LogSubTitle>

                <div>
                    <table>
                        <thead>
                            <tr>
                                <th>{i18n.t("date")}</th>
                                <th>{i18n.t("Type")}</th>
                                <th>{i18n.t("transaction-amount1")}</th>
                                <th>{i18n.t("by")}</th>
                                <th>{i18n.t("note-text")}</th>
                            </tr>
                        </thead>
                        <tbody>
                        {props.student.logs && props.student.logs.map((log, index) => {
                            return (
                                <tr key={"_logI"+ index}>
                                    <td>{moment(log.timestamp).format("DD-MM-yyyy")}</td>
                                    <td>{i18n.t(log.title?"reward":"transaction")}</td>
                                    <td>{log.amount}</td>
                                    <td>{log.displayname?log.displayname:log.username}</td>
                                    <td style={{width:"350px"}}>{log.title?log.title:log.text}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>
                
            </TransactionLog>
        </Container>
    </>)
}

export default ManagementSide;